/* src/components/recruit/MainVisual.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "../../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", {});
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, srcset: true, alt: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/top-02.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/top-02-sp.jpg 768w, /images/top-02.jpg");
			attr(img, "alt", "縁JOY");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

class MainVisual extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default MainVisual;
//# sourceMappingURL=MainVisual.svelte.js.map
